module.exports = __webpack_public_path__ + "static/media/memory.718b3ba4.svg";